import { SelectItem } from 'primeng/api';

import { Observable } from 'rxjs';

import { PaperAuthorsAffiliationRendererComponent } from 'editing-tool/src/app/shared/components/paper/steps/authors/renderers/affiliation/paper-authors-affiliation-renderer.component';
import { PaperAuthorsFirstNameRendererComponent } from 'editing-tool/src/app/shared/components/paper/steps/authors/renderers/first-name/paper-authors-first-name-renderer.component';
import { RendererMetadata } from 'sc-common';
import { ApiMemberAddressDetails } from 'sc-common/core/services/open-api/main-api-client';

export class PaperAuthorsRenderers {

    public static affiliation(
        getAffiliationAction: (memberId: number) => Observable<ApiMemberAddressDetails>,
        countries$: Observable<SelectItem[]>): RendererMetadata<PaperAuthorsAffiliationRendererComponent> {

        return {
            componentType: PaperAuthorsAffiliationRendererComponent,
            initializer: inst => {
                inst.getAffiliationAction = getAffiliationAction;
                inst.countries$ = countries$;
            }
        };
    }

    public static firstName(): RendererMetadata<PaperAuthorsFirstNameRendererComponent> {
        return {
            componentType: PaperAuthorsFirstNameRendererComponent
        };
    }
}
